import { withStyles } from '@material-ui/core/styles'
import styles from './LoadingSpinner.styles'

export default withStyles(styles)
